export const SEARCH_MODULE_NAMESPACE = 'search';
export const SEARCH_LOADING = 'SEARCH_LOADING';
export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_REQUEST_BYKEYS = 'SEARCH_REQUEST_BYKEYS';
export const SEARCH_REQUEST_BYID = 'SEARCH_REQUEST_BYID'
export const SEARCH_REQUEST_BYKEYS_FORCE = 'SEARCH_REQUEST_BYKEYS_FORCE';
export const SEARCH_AUTOCOMPLETE = 'SEARCH_AUTOCOMPLETE';
export const SEARCH_RECIEVE = 'SEARCH_RECIEVE';
export const SEARCH_RECIEVE_LOADING = 'SEARCH_RECIEVE_LOADING';
export const SEARCH_GET_DECLARANTS = 'SEARCH_GET_DECLARANTS';
export const SEARCH_GET_CONTRACTORS = 'SEARCH_GET_CONTRACTORS';
export const SEARCH_ASSIGN_TO_ME = 'SEARCH_ASSIGN_TO_ME';


// WEBPACK FOOTER //
// ./src/store/search/search-types.store.ts